import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DevelopmentStatus } from 'src/app/shared/utils/developmentStatus';

@Component({
  selector: 'app-modal-save',
  templateUrl: './save.component.html',
  styleUrls: ['./save.component.scss'],
})
export class SaveComponent implements OnInit {
  public developmentActionFormControl: FormControl;

  @Output() private emitCloseService = new EventEmitter<boolean>();
  @Output() private emitDismissService = new EventEmitter<boolean>();
  @Output() private emitSendService = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {
    this.createDevelopmentActionFormControl();
  }

  private createDevelopmentActionFormControl(): void {
    this.developmentActionFormControl = new FormControl(
      DevelopmentStatus.ACTIVED
    );
  }

  public onClose(): void {
    this.emitCloseService.emit(true);
  }

  public onDismiss(): void {
    this.emitDismissService.emit();
  }

  public onSend(): void {
    this.emitSendService.emit(this.developmentActionFormControl.value);
    this.emitCloseService.emit(true);
  }
}
